var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-card',[_c('b-card-body',[_c('Search')],1)],1),_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('SupplierProducts')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }